import useStyles from "../../styles";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Chip,
  FormLabel,
  IconButton,
  TextField,
  Tooltip,
  Checkbox,
  Select,
  MenuItem,
} from "@material-ui/core";
import Autocomplete, { createFilterOptions } from "@material-ui/lab/Autocomplete";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import {
  fetchExamDate,
  fetchExamByDate,
  fetchCenterByDate,
} from "../../service/services";
import { toast } from "react-toastify";
import SaveIcon from "@material-ui/icons/Save";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const SELECT_ALL_OPTION = { id: "__select_all__", exam_code: "Select All", exam_name: "", center_name: "Select All" };
const filterOptions = createFilterOptions();

function ReportHeader({
  exportApi,
  setLoaderOpen,
  setSelectedExam,
  selectedExam,
  selectedExamType,
  setSelectedExamType,
  fetchData,
  setSelectedCenter,
  selectedCenter,
  showSave = true,
  examBase = true,
  setDate = () => { },
  fileName,
  examType = "main",
}) {
  const classes = useStyles();
  const navigate = useNavigate();

  const [examDate, setExamDate] = useState([]);
  const [selectedExamDate, setSelectedExamDate] = useState("");

  const [exam, setExam] = useState([]);
  const [center, setCenter] = useState([]);

  const [fileURL, setFileURL] = useState("");

  const handleExamDateChange = (event) => {
    setSelectedExamDate(event.target.value);
    setDate(event.target.value);
    setSelectedExam("");
    setSelectedCenter && setSelectedCenter([]);
  };

  // ── single-select exam (examBase = true) ────────────────────────────────
  const handleExamChange = (_event, value) => {
    setSelectedExam(value ? value.id : "");
  };

  // ── multi-select exam (examBase = false) ────────────────────────────────
  const handleExamChange2 = (_event, value) => {
    setSelectedExam(value.map((e) => e.id));
  };

  // ── multi-select center ─────────────────────────────────────────────────
  const handleCenterChange = (_event, value) => {
    setSelectedCenter(value.map((c) => c.id));
  };

  const fetchExamDateAPi = async () => {
    try {
      const response = await fetchExamDate();
      setExamDate(response.exams);
    } catch (error) {
      console.log("Error fetching question paper:", error);
    }
  };

  useEffect(() => {
    fetchExamDateAPi();
  }, []);

  const effectiveExamType = selectedExamType !== undefined ? selectedExamType : examType;

  const fetchExamAPi = async () => {
    try {
      const response = await fetchExamByDate(selectedExamDate, effectiveExamType);
      setExam(response.exams);
    } catch (error) {
      console.log("Error fetching question paper:", error);
    }
  };
  const fetchCenterAPi = async () => {
    try {
      const response = await fetchCenterByDate(selectedExamDate);
      setCenter(response.centers);
    } catch (error) {
      console.log("Error fetching question paper:", error);
    }
  };

  useEffect(() => {
    if (selectedExamDate) {
      fetchExamAPi(selectedExamDate);
      fetchCenterAPi();
    }
  }, [selectedExamDate, effectiveExamType]);

  useEffect(() => {
    if (selectedExamType && setSelectedExam) {
      setSelectedExam("");
    }
  }, [selectedExamType, setSelectedExam]);

  // const handleExportClick = async () => {
  //   try {
  //     if (!selectedExam) {
  //       toast.error("Export file is not available for this.");
  //       return;
  //     }

  //     setLoaderOpen(true); // show loader before API call

  //     // ✅ use exportApi instead of Report2Api
  //     const response = await exportApi(selectedExam);

  //     if (response.success) {
  //       setFileURL(response.file_url);
  //       window.open(response.file_url, "_blank");
  //       toast.success("CSV has been downloaded successfully.");
  //     } else {
  //       toast.error("Failed to download the CSV file.");
  //     }
  //   } catch (error) {
  //     console.error("API Error:", error);
  //     const errorMessage =
  //       error.response?.data?.message ||
  //       "An error occurred while fetching the data.";
  //     toast.error(errorMessage);
  //   } finally {
  //     setLoaderOpen(false); // ✅ always close loader
  //   }
  // };

  const getErrorMessage = async (res) => {
    if (!res) return null;
    if (res.success === false) return res.message;
    if (res.data?.success === false) return res.data.message;
    if (res.data instanceof Blob && res.data.type === "application/json") {
      try {
        const parsed = JSON.parse(await res.data.text());
        if (parsed?.success === false) return parsed.message;
      } catch (e) { }
    }
    return null;
  };

  const handleExportClick = async () => {
    try {
      if (!selectedExam) {
        toast.error("Export file is not available for this.");
        return;
      }

      setLoaderOpen(true);

      const response = await exportApi(selectedExam);

      const errorMsg = await getErrorMessage(response);
      if (errorMsg) {
        toast.error(errorMsg);
        setLoaderOpen(false);
        return;
      }

      if (response.data && response.data.file_url) {
        const fileUrl = response.data.file_url;

        const link = document.createElement("a");
        link.href = fileUrl;
        link.download = `${fileName || "Report"}.csv`;
        document.body.appendChild(link);
        link.click();
        link.remove();
        toast.success("CSV has been downloaded successfully.");
        setLoaderOpen(false);
      } else if (response.data) {
        const responseData = response.data;
        const headers = response.headers || {};
        const contentType = headers["content-type"] || (responseData instanceof Blob ? responseData.type : "");

        let extension = "csv";
        if (contentType.includes("spreadsheetml") || contentType.includes("excel")) {
          extension = "xlsx";
        } else if (contentType.includes("zip")) {
          extension = "zip";
        } else if (contentType.includes("pdf")) {
          extension = "pdf";
        }

        const blob = responseData instanceof Blob
          ? responseData
          : new Blob([responseData], { type: contentType || "text/csv;charset=utf-8;" });

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        const downloadName = `${fileName || "Report"}.${extension}`;
        link.setAttribute("download", downloadName);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
        toast.success("CSV has been downloaded successfully.");
        setLoaderOpen(false);
      } else {
        toast.error("Failed to download the CSV file.");
        setLoaderOpen(false);
      }

      // if (response) {
      //   // Service level success check
      //   if (response.success === false) {
      //     toast.error(response.message || "Failed to download the file.");
      //     return;
      //   }

      //   // Extract data and content type
      //   const responseData = response.data !== undefined ? response.data : response;
      //   const headers = response.headers || {};
      //   const contentType = headers["content-type"] || (responseData instanceof Blob ? responseData.type : "");

      //   // Determine file extension
      //   let extension = "csv"; // default
      //   if (contentType.includes("spreadsheetml") || contentType.includes("excel")) {
      //     extension = "xlsx";
      //   } else if (contentType.includes("zip")) {
      //     extension = "zip";
      //   } else if (contentType.includes("pdf")) {
      //     extension = "pdf";
      //   } else if (contentType.includes("text/csv")) {
      //     extension = "csv";
      //   }

      //   // Convert to blob if it's not already one
      //   const blob = responseData instanceof Blob ? responseData : new Blob([responseData], { type: contentType || "text/csv;charset=utf-8;" });

      //   const url = window.URL.createObjectURL(blob);

      //   const link = document.createElement("a");
      //   link.href = url;
      //   link.download = `${fileName || "Report"}.${extension}`;

      //   document.body.appendChild(link);
      //   link.click();

      //   document.body.removeChild(link);
      //   window.URL.revokeObjectURL(url);

      //   toast.success(`${extension.toUpperCase()} downloaded successfully.`);
      // } else {
      //   toast.error("Failed to download the file.");
      // }
    } catch (error) {
      console.error("API Error:", error);
      toast.error("An error occurred while fetching the data.");
    } finally {
      setLoaderOpen(false);
    }
  };

  const handleApplyClick = async () => {
    if (!selectedExam && examBase) {
      toast.error("Please select an exam before applying.");
      return;
    }
    try {
      await fetchData(selectedExam); // ✅ call your working API
      // toast.success("Attendance successfully.");
    } catch (error) {
      console.error("Apply Error:", error);
      toast.error("Failed to fetch data.");
    }
  };

  // Derive selected objects for Autocomplete value props
  const selectedExamObj = examBase
    ? exam.find((e) => e.id === selectedExam) || null
    : null;

  const selectedExamObjs = !examBase
    ? exam.filter((e) => (selectedExam || []).includes(e.id))
    : [];

  const selectedCenterObjs = !examBase
    ? center.filter((c) => (selectedCenter || []).includes(c.id))
    : [];

  const examTypeOptions = [
    { id: "", label: "All Exam Types" },
    { id: "main", label: "Main" },
    { id: "demo", label: "Feedback" },
  ];

  const filteredExamOptions = selectedExamType
    ? exam.filter((examItem) => {
      const examType = String(examItem.exam_type || examItem.type || "").toLowerCase();
      if (selectedExamType === "demo") {
        return examType === "demo" || examType === "feedback";
      }
      return examType === selectedExamType;
    })
    : exam;

  return (
    <>
      <div
        className={`${classes.w100} ${classes.bgblue} ${classes.inputdropdowniconcolor}  ${classes.alignitemscenter}   ${classes.mt1} ${classes.borderradius6px}   ${classes.inputpadding} ${classes.inputborderwhite}  ${classes.inputplaceholdercolor}   ${classes.dflex}`}
      >
        <div className={`${classes.w100} ${classes.dflex}`}>
          {/* ── Date picker ──────────────────────────────────────────────── */}
          <div
            className={`${classes.dflex}  ${classes.mx0_5} ${classes.flexdirectioncolumn} ${classes.w24} ${classes.my1}`}
          >
            <FormLabel
              className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} 
              ${classes.lineheight}`}
            ></FormLabel>
            {/* <Select
              labelId="batch-label"
              id="examdate"
              value={selectedExamDate}
              onChange={handleExamDateChange}
              displayEmpty
              className={classes.selectEmpty}
              MenuProps={menuProps}
              variant="outlined"
            >
              <MenuItem disabled value="">
                <em className={classes.defaultselect}>Select Date</em>
              </MenuItem>
              {examDate &&
                examDate.map((st) => (
                  <MenuItem key={st.start_date} value={st.start_date}>
                    {st?.start_date}
                  </MenuItem>
                ))}
            </Select> */}
            <TextField
              type="date"
              variant="outlined"
              required
              className={`${classes.whiteCalendar}`}
              value={selectedExamDate}
              onChange={handleExamDateChange}
              placeholder="Select Date"
            />
          </div>

          {setSelectedExamType && (
            <div
              className={`${classes.dflex}  ${classes.mx0_5} ${classes.flexdirectioncolumn} ${classes.w24} ${classes.my1}`}
            >
              <FormLabel
                className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} 
              ${classes.lineheight}`}
              ></FormLabel>
              <Select
                labelId="exam-type-label"
                id="exam-type"
                value={selectedExamType}
                onChange={(e) => setSelectedExamType(e.target.value)}
                displayEmpty
                variant="outlined"
                className={`${classes.whiteCalendar}`}
              >
                {examTypeOptions.map((typeOption) => (
                  <MenuItem key={typeOption.id} value={typeOption.id}>
                    {typeOption.label}
                  </MenuItem>
                ))}
              </Select>
            </div>
          )}

          {/* ── Single-select Exam (examBase = true) ─────────────────────── */}
          {examBase && (
            <div
              className={`${classes.dflex}  ${classes.mx0_5} ${classes.flexdirectioncolumn} ${classes.w24} ${classes.my1}`}
            >
              <FormLabel
                className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} 
              ${classes.lineheight}`}
              ></FormLabel>
              <Autocomplete
                id="exam-single-autocomplete"
                options={filteredExamOptions}
                getOptionLabel={(option) =>
                  `${option.exam_code} - ${option.exam_name}`
                }
                getOptionSelected={(option, value) => option.id === value.id}
                value={selectedExamObj}
                onChange={handleExamChange}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Select Exam"
                    variant="outlined"
                    className={`${classes.whiteCalendar}`}
                  />
                )}
              />
            </div>
          )}

          {/* ── Multi-select Exam + Center (examBase = false) ─────────────── */}
          {!examBase && (
            <>
              {/* Multi-select Exam */}
              <div
                className={`${classes.dflex} ${classes.mx0_5} ${classes.flexdirectioncolumn} ${classes.w24} ${classes.my1}`}
              >
                <Autocomplete
                  id="exam-multi-autocomplete"
                  multiple
                  disableCloseOnSelect
                  options={[SELECT_ALL_OPTION, ...exam]}
                  getOptionLabel={(option) =>
                    option.id === "__select_all__"
                      ? "Select All"
                      : `${option.exam_code} - ${option.exam_name}`
                  }
                  getOptionSelected={(option, value) => option.id === value.id}
                  filterOptions={(options, params) => {
                    const filtered = filterOptions(
                      options.filter((o) => o.id !== "__select_all__"),
                      params
                    );
                    return [SELECT_ALL_OPTION, ...filtered];
                  }}
                  value={selectedExamObjs}
                  onChange={(event, value) => {
                    if (value.some((v) => v.id === "__select_all__")) {
                      if (selectedExamObjs.length === exam.length) {
                        handleExamChange2(event, []);
                      } else {
                        handleExamChange2(event, exam);
                      }
                    } else {
                      handleExamChange2(event, value);
                    }
                  }}
                  renderTags={(tagValue, getTagProps) =>
                    tagValue.map((option, index) => (
                      <Chip
                        key={option.id}
                        label={option.exam_code}
                        size="small"
                        {...getTagProps({ index })}
                      />
                    ))
                  }
                  renderOption={(option, { selected }) => (
                    <>
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 8 }}
                        checked={
                          option.id === "__select_all__"
                            ? selectedExamObjs.length === exam.length && exam.length > 0
                            : selected
                        }
                        indeterminate={
                          option.id === "__select_all__" &&
                          selectedExamObjs.length > 0 &&
                          selectedExamObjs.length < exam.length
                        }
                        size="small"
                      />
                      {option.id === "__select_all__"
                        ? "Select All"
                        : `${option.exam_code} - ${option.exam_name}`}
                    </>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder={
                        selectedExamObjs.length === 0 ? "Select Exam" : ""
                      }
                      variant="outlined"
                      className={`${classes.whiteCalendar}`}
                    />
                  )}
                />
              </div>

              {/* Multi-select Center */}
              <div
                className={`${classes.dflex} ${classes.mx0_5} ${classes.flexdirectioncolumn} ${classes.w24} ${classes.my1}`}
              >
                <Autocomplete
                  id="center-multi-autocomplete"
                  multiple
                  disableCloseOnSelect
                  options={[SELECT_ALL_OPTION, ...center]}
                  getOptionLabel={(option) =>
                    option.id === "__select_all__" ? "Select All" : option.center_name
                  }
                  getOptionSelected={(option, value) => option.id === value.id}
                  filterOptions={(options, params) => {
                    const filtered = filterOptions(
                      options.filter((o) => o.id !== "__select_all__"),
                      params
                    );
                    return [SELECT_ALL_OPTION, ...filtered];
                  }}
                  value={selectedCenterObjs}
                  onChange={(event, value) => {
                    if (value.some((v) => v.id === "__select_all__")) {
                      if (selectedCenterObjs.length === center.length) {
                        handleCenterChange(event, []);
                      } else {
                        handleCenterChange(event, center);
                      }
                    } else {
                      handleCenterChange(event, value);
                    }
                  }}
                  renderTags={(tagValue, getTagProps) =>
                    tagValue.map((option, index) => (
                      <Chip
                        key={option.id}
                        label={option.center_name}
                        size="small"
                        {...getTagProps({ index })}
                      />
                    ))
                  }
                  renderOption={(option, { selected }) => (
                    <>
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 8 }}
                        checked={
                          option.id === "__select_all__"
                            ? selectedCenterObjs.length === center.length && center.length > 0
                            : selected
                        }
                        indeterminate={
                          option.id === "__select_all__" &&
                          selectedCenterObjs.length > 0 &&
                          selectedCenterObjs.length < center.length
                        }
                        size="small"
                      />
                      {option.id === "__select_all__" ? "Select All" : option.center_name}
                    </>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder={
                        selectedCenterObjs.length === 0 ? "Select Center" : ""
                      }
                      variant="outlined"
                      className={`${classes.whiteCalendar}`}
                    />
                  )}
                />
              </div>
            </>

            // <div
            //   className={`${classes.dflex}  ${classes.mx0_5} ${classes.flexdirectioncolumn} ${classes.w24} ${classes.my1}`}
            // >
            //   <FormLabel
            //     className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400}
            //   ${classes.lineheight}`}
            //   ></FormLabel>
            //   <Select
            //     labelId="category-label"
            //     id="state"
            //     value={selectedCenter}
            //     onChange={handleCenterChange}
            //     displayEmpty
            //     // className={classes.selectEmpty}
            //     MenuProps={menuProps}
            //     variant="outlined"
            //   >
            //     <MenuItem disabled value="">
            //       <em className={classes.defaultselect}>Select Center</em>
            //     </MenuItem>
            //     {center?.map((data, index) => {
            //       return (
            //         <MenuItem value={data.id} key={index}>
            //            {data.center_name}
            //         </MenuItem>
            //       );
            //     })}
            //   </Select>
            // </div>
          )}

          <Button
            variant="contained"
            color="primary"
            className={`${classes.transparentbtn} ${classes.mx0_5} ${classes.my1}`}
            onClick={handleApplyClick}
          >
            Apply
          </Button>
        </div>

        {/* <Button
          variant="contained"
          color="primary"
          className={`${classes.transparentbtn} ${classes.mx0_5}`}
          onClick={handleExportClick}
        >
          Export
        </Button> */}

        <Tooltip title="Export">
          <IconButton
            color="primary"
            className={`${classes.mx0_5}`}
            onClick={showSave && handleExportClick}
            style={{ color: "#fff" }}
          >
            {showSave && <SaveIcon fontSize="large" />}
          </IconButton>
        </Tooltip>

        <div style={{ padding: "10px" }}></div>
      </div>
    </>
  );
}
export default ReportHeader;
